<template>
  <v-dialog v-model="localDialog" max-width="800" lazy>
    <v-img
      :src="image"
      :lazy-src="'http://www.sclance.com/pngs/image-placeholder-png/image_placeholder_png_698412.png'"
      class="grey lighten-2"
    >
      <template #placeholder>
        <v-layout fill-height align-center justify-center ma-0>
          <v-progress-circular indeterminate color="grey lighten-5" />
        </v-layout>
      </template>
    </v-img>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogImage',
  props: {
    image: {
      type: String,
      default: '',
      required: false,
    },
    dialog: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    localDialog: {
      get() {
        return this.dialog
      },
      set() {
        this.$emit('update:dialog', false)
      },
    },
  },
}
</script>
